import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class CuvetteRack extends React.Component {
  componentWillMount() {
    this.props.createCuvetteRack({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"CuvetteRack_"+this.props.id}
          className={'CuvetteRack'}>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

CuvetteRack.propTypes = {
  createCuvetteRack: PropTypes.func,
};

CuvetteRack.defaultProps = {};
